<template>
  <div class="bg-secondary-50 max-h-full">
    <div class="flex h-[4rem] bg-white shadow-sm border-b border-gray-200 items-center">
      <div class="flex w-full px-4 items-center gap-10">
        <div class="w-10 h-10 bg-primary text-black font-bold flex items-center justify-center">LS</div>
        <div class="grow">
          <div class="font-semibold text-xl">{{ legalDocumentTemplateStore?.document?.name }}</div>
          <div class="text-slate-500 text-sm">{{ legalDocumentTemplateStore?.document?.template_name }}</div>
        </div>
        <RouterLink :to="{ name: 'home' }" class="text-gray-500 hover:text-gray-700 flex items-center gap-2">
          <span>Dokument schließen</span>
        </RouterLink>
        <LSButton size="small" type="secondary" variant="outline" @click="generatePDF">
          <template #icon>
            <DownloadIcon />
          </template>
          Download
        </LSButton>
        <StatusLabel
          class="h-8"
          :label="legalDocumentTemplateStore?.document?.workflow_progress === 'finalized' ? 'Fertiggestellt' : 'Entwurf'"
          :status="legalDocumentTemplateStore?.document?.workflow_progress === 'finalized' ? 'done' : 'warn'"
        />
      </div>
    </div>
    <div class="flex h-[calc(100vh-4rem)]">
      <!-- Static sidebar for desktop -->
      <div class="hidden md:flex md:w-72 lg:w-96 md:flex-col md:inset-y-0 max-h-[100vh] overflow-hidden bg-white px-4 py-8">
        <TableOfContents />
      </div>
      <div class="flex flex-col flex-1 max-h-[100vh] overflow-hidden">
        <main class="max-h-full overflow-y-scroll">
          <div class="max-w-[1024px] px-4 lg:px-8">
            <slot />
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LSButton from '@/components/LSButton.vue'
import DownloadIcon from '@/assets/icons/24/download.svg?component'
import { useRoute } from 'vue-router'

import TableOfContents from '@/questionnaire/components/LegalDocument/TableOfContents.vue'
import { downloadDocument } from '@/services/documentsService'
import { useQuestionnaireStore } from '@/questionnaire/stores/questionnaire'
import { errorNotification } from '@/utils/notifications'

import { ref, watch } from 'vue'
import StatusLabel from '@/components/StatusLabel.vue'

const legalDocumentTemplateStore = useQuestionnaireStore()
const documentId = useRoute().params.documentId as string

const data = ref<{ documentStatus: 'draft' | 'finalized' }>({
  documentStatus: legalDocumentTemplateStore?.document?.workflow_progress,
})

const setDocumentStatus = () => {
  data.value.documentStatus = legalDocumentTemplateStore?.document?.workflow_progress
}

watch(legalDocumentTemplateStore.document, () => {
  setDocumentStatus()
})

const generatePDF = () => {
  downloadDocument(documentId, legalDocumentTemplateStore?.document?.template_name || 'vertragsdokument').catch(error => {
    errorNotification(`Error generating PDF: ${error.data.message?.template_variable}`)
  })
}
</script>
